var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 18.999,
  r: 17.417,
  fill: "#8C919F"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#youtube_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.5 12s6.13 0 7.659.418a2.48 2.48 0 0 1 1.733 1.769h-.002c.41 1.559.41 4.813.41 4.813 0 .013 0 3.258-.41 4.814a2.48 2.48 0 0 1-1.733 1.768C25.63 26 19.5 26 19.5 26c-.034 0-6.134-.001-7.657-.418a2.48 2.48 0 0 1-1.733-1.768c-.409-1.556-.41-4.8-.41-4.814 0 0 0-3.254.41-4.813a2.48 2.48 0 0 1 1.733-1.769C13.366 12.001 19.466 12 19.5 12m-1.96 9.999L22.634 19l-5.094-3z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "youtube_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.7 12h19.6v14H9.7z"
})))));
export default SvgYoutube;